
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M7.808 2.332C5.203 3.148 3.333 5.377 3.333 8v6L0 16v1h20v-1l-3.333-2V8c0-2.623-1.87-4.852-4.475-5.668.02-.108.03-.219.03-.332 0-1.105-.995-2-2.222-2-1.227 0-2.222.895-2.222 2 0 .113.01.224.03.332zM12 18a2 2 0 11-4 0h4z"}}),_c('ellipse',{attrs:{"cx":"15.789","cy":"4","rx":"4.211","ry":"4"}})])])
          )
        }
      }
    